var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinuspl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon othersSVGs",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.57226,
    cy: 9.08392,
    r: 7.83379,
    stroke: "currentColor",
    strokeWidth: 1.59243
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8187 9.08392H5.32577",
    stroke: "currentColor",
    strokeWidth: 1.59243
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8187 9.08392H5.32577",
    stroke: "currentColor",
    strokeWidth: 1.59243
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8187 9.08392H5.32577",
    stroke: "currentColor",
    strokeWidth: 1.59243
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinuspl);
export default __webpack_public_path__ + "static/media/minuspl.34dfcfd3d85036c404b0a45d1f666796.svg";
export { ForwardRef as ReactComponent };